import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import DatePicker from "react-datepicker";
import { ApiService } from "../../../services/ApiService";
import { Formik, Form, Field } from "formik";
import { useAlert } from "react-alert";
import Select from "react-select";

export default function AddMunch({ closeModal, users, getAllMuchAndLearn }) {
  const alert = useAlert();
  const [loader, setLoader] = useState(false);
  const [usersName, setUsersName] = useState("");
  const [usersEmail, setUsersEmail] = useState("");

  const handlePiredChange = (data) => {
    const emails = [];
    data
      ? data.map((val) => emails.push({ label: val.value, value: val.value }))
      : "";
    setUsersEmail(emails);
    setUsersName(data);
  };

  const load = <span className="fa fa-spin fa-spinner"></span>;
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          name: "",
          presentation_type: "",
          due_date: "",
          email: "",
          users_email: "",
          topic: "",
        }}
        onSubmit={async (values) => {
          if (values.presentation_type === "individual") {
            values.email = values.name;
            const user = users.find((u) => u.email === values.name);
            values.name = user.first_name + " " + user.last_name;
          } else if (values.presentation_type === "paired") {
            values.name = usersName;
            values.email = usersEmail;
            if (!values.name) alert.error("Presenter name is required");
            const nomerlizeName = values.name.map((obj) => obj.label);
            const nomerlizeEmail = values.email.map((obj) => obj.value);
            values.name = [...nomerlizeName];
            values.email = [...nomerlizeEmail];
          }

          setLoader(true);
          const date = new Date(values.due_date);
          date.setDate(date.getDate() + 1);
          values.due_date = date;
          try {
            const response = await ApiService.post(
              "trainings/create-munch-and-learn",
              values
            );
            if (response.data.type === false) {
              alert.error(response.data.msg);
              setLoader(false);
            } else if (response.data.type === true) {
              alert.success(response.data.msg);
              setLoader(false);
            }
            setLoader(false);
            closeModal();
            getAllMuchAndLearn();
          } catch (error) {
            setLoader(false);
          }
        }}
      >
        {({
          handleSubmit,
          values,
          isSubmitting,
          setFieldValue,
          handleChange,
        }) => (
          <Form>
            <div>
              <div className="form-group">
                <label>
                  Presentation Type <span className="text-danger"> * </span>
                </label>
                <select
                  type="text"
                  className="form-control"
                  id="presentation_type"
                  name="presentation_type"
                  onChange={handleChange}
                  value={values.presentation_type}
                  required
                >
                  <option value="">--Select Presentation Type--</option>
                  <option value="individual">Individual</option>
                  <option value="paired">Paired</option>
                  <option value="guest">Guest</option>
                  ))
                </select>
              </div>

              {values.presentation_type == "individual" ? (
                <div>
                  <div className="form-group">
                    <label>
                      Presenter <span className="text-danger"> * </span>
                    </label>
                    <select
                      type="text"
                      className="form-control"
                      name="name"
                      onChange={handleChange}
                      value={values.name}
                      required
                    >
                      <option value="">--Select User--</option>

                      {users.map((user, i) => (
                        <option value={user.email} key={i}>
                          {user.first_name + " " + user.last_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>
                      Presenter Email <span className="text-danger"> * </span>
                    </label>
                    <select
                      type="text"
                      className="form-control"
                      name="email"
                      // onChange={handleChange}
                      // value={users.map((user) =>
                      //   user.id === values.name ? user.email : null
                      // )}
                      value={values.name}
                    >
                      <option value={values.name}>{values.name}</option>
                    </select>
                  </div>
                </div>
              ) : null}

              {values.presentation_type == "paired" ? (
                <div>
                  <div className="form-group">
                    <label>
                      Presenter <span className="text-danger"> * </span>
                    </label>
                    <Select
                      required={true}
                      isMulti
                      value={usersName}
                      options={users.map((user) => ({
                        label: user.first_name + " " + user.last_name,
                        value: user.email,
                      }))}
                      onChange={(data) => handlePiredChange(data)}
                    />
                  </div>

                  <div className="form-group">
                    <label id="email">
                      Presenter Email <span className="text-danger"> * </span>
                    </label>

                    <Select
                      required
                      isMulti
                      value={usersEmail}
                      isDisabled={true}
                    />
                  </div>
                </div>
              ) : null}

              {values.presentation_type == "guest" ? (
                <div>
                  <div className="form-group">
                    <label>
                      Presenter <span className="text-danger"> * </span>
                    </label>
                    <Field
                      type="text"
                      id="tpoic"
                      className="form-control item"
                      name="name"
                      placeholder="Enter Guest Name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>
                      Presenter Email <span className="text-danger"> * </span>
                    </label>
                    <Field
                      type="text"
                      className="form-control"
                      name="email"
                      onChange={handleChange}
                      value={values.email}
                      placeholder="Enter Guest Email"
                      required
                    />
                    {/* <option value="">--Select--</option>
                      {users.map((user, i) => (
                        <option value={user.email} key={i}>
                          {user.email}
                        </option>
                      ))} */}
                  </div>
                </div>
              ) : null}
              <div className="form-group">
                <label>
                  Due Date <span className="text-danger"> * </span>
                </label>
                <div className="form-group">
                  <DatePicker
                    selected={Date.parse(values.due_date)}
                    dateFormat="MMMM d, yyyy"
                    className="form-control"
                    name="due_date"
                    minDate={new Date()}
                    onChange={(date) => setFieldValue("due_date", date)}
                    required
                    autoComplete="off"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>
                  Topic <span className="text-danger"> * </span>
                </label>
                <Field
                  type="text"
                  id="tpoic"
                  className="form-control item"
                  name="topic"
                  placeholder="Enter Topic"
                  required
                />
              </div>
              <div className="orm-group row">
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
                {/* <div className="col-md-10">
                  <button
                    type="submit"
                    className="btn btn-block nt-button-color-default"
                  >
                    Submit
                  </button>
                </div> */}
                <div className="col-md-10">
                  <button
                    type="submit"
                    // disabled={isSubmitting}
                    className="btn btn-block nt-button-color-default"
                  >
                    {loader ? load : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/addMunch.js